module.exports = __webpack_public_path__ + "img/pay (12).eae35fdf.png";